(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
    
class BrandsSlider {
  constructor(section) {
    this.section = section;
    this.scrollContainer = this.section.querySelector('.brands-grid');
    this.prevBtn = this.section.querySelector('.brands-arrow--prev');
    this.nextBtn = this.section.querySelector('.brands-arrow--next');

    if (!this.scrollContainer || !this.prevBtn || !this.nextBtn) return;

    this.init();
  }

  init() {
    this.updateButtons = this.updateButtons.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);

    this.prevBtn.addEventListener('click', this.onPrevClick);
    this.nextBtn.addEventListener('click', this.onNextClick);
    this.scrollContainer.addEventListener('scroll', this.updateButtons, { passive: true });
    
    const resizeObserver = new ResizeObserver(() => this.updateButtons());
    resizeObserver.observe(this.scrollContainer);

    this.updateButtons(); // Initial state
  }

  getScrollAmount() {
    const firstItem = this.scrollContainer.querySelector('.brand-item');
    if (!firstItem) return 300; // Fallback scroll amount

    const gridStyles = window.getComputedStyle(this.scrollContainer);
    const gridGap = parseFloat(gridStyles.gap) || 15;
    
    const itemWidth = firstItem.offsetWidth;
    return (itemWidth + gridGap) * 2;
  }

  updateButtons() {
    if (window.innerWidth < 990) {
      if (this.prevBtn) this.prevBtn.disabled = true;
      if (this.nextBtn) this.nextBtn.disabled = true;
      return;
    }
    const scrollLeft = this.scrollContainer.scrollLeft;
    const maxScroll = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;

    this.prevBtn.disabled = scrollLeft <= 0;
    this.nextBtn.disabled = scrollLeft >= maxScroll - 2;
  }

  onPrevClick() {
    const scrollAmount = this.getScrollAmount();
    const newPosition = this.scrollContainer.scrollLeft - scrollAmount;
    this.scrollContainer.scrollTo({
      left: newPosition,
      behavior: 'smooth'
    });
  }

  onNextClick() {
    const scrollAmount = this.getScrollAmount();
    const newPosition = this.scrollContainer.scrollLeft + scrollAmount;
    this.scrollContainer.scrollTo({
      left: newPosition,
      behavior: 'smooth'
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const brandSections = document.querySelectorAll('.brands-section');
  brandSections.forEach(section => {
    if (!section.dataset.initialized) {
      new BrandsSlider(section);
      section.dataset.initialized = true;
    }
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.closest('.brands-section');
  if (section && !section.dataset.initialized) {
    new BrandsSlider(section);
    section.dataset.initialized = true;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
